import { authActions as authActionsFromSlice } from '../reducers/auth';

export const authActions = { auth: authActionsFromSlice };
